
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'UILabel',
  props: {
    type: {
      type: String as PropType<'juniper' | 'cherry' | 'honey' | 'amber' | 'neutral'>,
      required: true
    }
  }
})
